import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const location = useLocation();

  const isAdminRoute =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("admin");

  const roleName = localStorage.getItem("roleName");
  const isAdminFull = roleName === "Admin";
  const isComandoRole = roleName === "Comando";

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("name");
    localStorage.removeItem("isMaster");
    localStorage.removeItem("roleName");
    localStorage.removeItem("roleType");
    window.location.href = "/login";
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-body-tertiary fixed-top no-print">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/admin">
            <img src="/logo.png" alt="Logo" width="58px" />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  to="/admin"
                >
                  Início
                </Link>
              </li>
              {!isComandoRole && (
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/schools">
                    Escolas
                  </Link>
                </li>
              )}
              {!isComandoRole && (
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/users">
                    Usuários
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link className="nav-link" to="/admin/reservations">
                  Reservas
                </Link>
              </li>
              {!isComandoRole && (
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/reports">
                    Relatórios
                  </Link>
                </li>
              )}
              {!isComandoRole && (
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/block-user">
                    Bloqueios
                  </Link>
                </li>
              )}
              {isAdminFull && (
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/rules">
                    Regras
                  </Link>
                </li>
              )}
              {localStorage.getItem("roleType") === "ADMIN" && (
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/roles">
                    Grupos e Permissões
                  </Link>
                </li>
              )}
              {localStorage.getItem("roleType") === "ADMIN" && (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Logs
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item" to="/admin/activity-logs">
                        Logs de Atividade
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/admin/system-logs">
                        Logs do Sistema
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
            </ul>
          </div>

          {isAdminRoute ? (
            <>
              {!isComandoRole && (
                <Link to="/" target="_blank" rel="noopener noreferrer">
                  <div>Acessar DEJE</div>
                </Link>
              )}

              <div
                onClick={() => handleLogout()}
                style={{ paddingLeft: "24px", cursor: "pointer" }}
              >
                Sair
              </div>
            </>
          ) : (
            <div className="text-end">
              <small>
                <small>
                  <i>
                    Apenas administradores podem
                    <br />
                    ver essa barra de navegação
                  </i>
                </small>
              </small>
            </div>
          )}
        </div>
      </nav>

      <div className="no-print" style={{ marginTop: "85px" }}></div>
    </>
  );
}
